module.exports = __webpack_public_path__ + "static/Sonyax5a-090ca10bb92631b6bf81c022eae1170e.png";